<ion-header mode="md">
    <ion-toolbar mode="ios" color="primary" performance class="ion-text-center">
        <ion-buttons slot="start">
            <ion-button fill="clear" mode="ios" (click)="goToProcesses()">
                {{ 'generic.goBack' | translate }}
            </ion-button>
        </ion-buttons>
        <ion-title>
            {{ 'generic.users' | translate }}
        </ion-title>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
    <ion-card>
        <ion-card-content>
            <p>
                {{createdAt | date: 'dd/MM/yyyy h:mm z'}}
            </p>
        </ion-card-content>
    </ion-card>
    <div class="inner-content">
        <app-users-tabs
                [tabs]="tabs"
                (selectTab)="selectTab($event)"
                style="margin-bottom: 15px;"
        ></app-users-tabs>

        <app-list-search
                placeholder="Digite o nome do usuário"
                background="white"
                (triggerSearch)="triggerSearch($event)"
        ></app-list-search>

        <table mat-table [dataSource]="users" class="mat-elevation-z8" aria-label="Users List">

            <ng-container matColumnDef="imageUrl">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let row">
                    <ng-container *ngIf="row?.imageUrl">
                        <img class="logo" [src]="row?.imageUrl" default="" alt=""/>
                    </ng-container>
                </td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> Nome do Usuário</th>
                <td mat-cell *matCellDef="let row">
                    {{ row?.name }}
                </td>
            </ng-container>

            <ng-container matColumnDef="jobTitle">
                <th mat-header-cell *matHeaderCellDef> Categoria</th>
                <td mat-cell *matCellDef="let row">
                    {{ row?.rank }}
                </td>
            </ng-container>

            <ng-container matColumnDef="responsible">
                <th mat-header-cell *matHeaderCellDef> Responsável</th>
                <td mat-cell *matCellDef="let row">
                    {{ row?.responsible }}
                </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef> Status</th>
                <td mat-cell *matCellDef="let row">
                    <p style="padding: 5px 25px;">
                        {{ row?.status }}
                    </p>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <app-pagination *ngIf="tabs[selectedTabIndex] && tabs[selectedTabIndex].count && notSearching"
                        [setPagination]="{ 'itemsCount': tabs[selectedTabIndex].count, 'pageSize': pageSize }"
                        (goToPage)="goToPage($event)"
        ></app-pagination>
    </div>
</ion-content>